import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment/locale/ja'
moment.locale('ja')

function PeriodBadge (props) {
  const periodFrom = moment(props.periodFrom)
  const periodTo = moment(props.periodTo)
  const now = moment()

  let status = ''
  if (now.isBefore(periodFrom)) {
    status = '契約開始前'
  } else if (periodTo.add(1, 'd').isBefore(now)) {
    status = '契約切れ'
  } else {
    const diffMonth = periodTo.diff(now, 'month')
    if (diffMonth > 1) {
      status = `残り${diffMonth}ヵ月`
    } else {
      const diffDay = periodTo.diff(now, 'day')
      status = diffDay === 0 ? '本日まで' : `残り${diffDay}日`
    }
  }

  return (
    <>
      <div className={`badge my-badge-period ${status === '契約切れ' ? 'badge-danger' : 'badge-dark'}`}>
        {`${status}（${props.periodFrom} ～ ${props.periodTo}）`}
      </div>
    </>
  )
}

PeriodBadge.propTypes = {
  periodFrom: PropTypes.string,
  periodTo: PropTypes.string
}

export default function renderPeriodBadge (element = null) {
  const elem = element ? $(element).find('.period-badge') : $('.period-badge')
  elem.each((i, el) => {
    const qel = $(el)
    const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる

    ReactDOM.render(<PeriodBadge {...props}/>, el)

    Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
      qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
      return 0
    })
  })
}
